import React from "react";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import { LinearProgress } from "material-ui/Progress";
import { withStyles } from "material-ui/styles";
import isMobile from "ismobilejs";
import { isAnswer } from "utils/formatter";
import Dialog, {
  DialogActions,
  DialogContent
} from "material-ui/Dialog";
import Typography from "material-ui/Typography";
import storage from "utils/storage";

const browserStyles = theme => ({
  container: {
    padding: 20,
    margin: "20px auto",
    width: 1100,
    backgroundColor: theme.palette.answer.backgroundColor,
    height: 570,
    position: "relative"
  },
  attrNameDiv: {
    margin: "20px 40px"
  },
  attrName: {
    fontSize: "1.6rem",
    borderBottom: `5px solid ${theme.palette.answer.borderColor}`,
    padding: "3px 20px"
  },
  selectBtnRaised: {
    backgroundColor: theme.palette.answer.main,
    "&:hover": {
      backgroundColor: theme.palette.answer.light
    }
  },
  selectButtonsDiv: {
    height: 310,
    background: "white",
    border: "10px solid #b1bed4",
    overflow: "scroll",
    margin: 30,
    padding: 5
  },
  selectButton: {
    margin: 10
  },
  progressWrapper: {
    position: "absolute",
    bottom: 100,
    width: "100%",
    margin: "0 -20px"
  },
  progress: {
    padding: "0 30px"
  },
  progressLabel: {
    margin: "0 10px"
  },
  progressBar: {
    height: 30,
    borderRadius: 10
  },
  progressBarColor: {
    backgroundColor: theme.palette.answer.light
  },
  footer: {
    position: "absolute",
    bottom: 15,
    margin: 10,
    width: "95%"
  },
  btnGroup: {
    display: "flex",
    justifyContent: "space-between"
  },
  tempSaveBtn: {
    display: "flex",
  }
});

const mobileStyles = theme => ({
  container: {
    margin: 10,
    padding: 10,
    backgroundColor: theme.palette.answer.backgroundColor
  },
  attrNameDiv: {
    marginBottom: 20
  },
  attrName: {
    borderBottom: `2px solid ${theme.palette.answer.borderColor}`,
    padding: "3px 10px"
  },
  selectBtnRaised: {
    backgroundColor: theme.palette.answer.main,
    "&:hover": {
      backgroundColor: theme.palette.answer.light,
      // Reset on mouse devices
      "@media (hover: none)": {
        backgroundColor: theme.palette.answer.main
      }
    }
  },
  selectButtonsDiv: {
    margin: 10,
    minHeight: 190
  },
  selectButtonsGrid: {
    display: "grid"
  },
  selectButton: {
    margin: 10
  },
  progressWrapper: {
    margin: "10px 10px 30px"
  },
  progress: {
    padding: "0 10px"
  },
  progressLabel: {
    margin: "0 10px"
  },
  progressBar: {
    borderRadius: 10
  },
  progressBarColor: {
    backgroundColor: theme.palette.answer.light
  }
});

class AnswerAttribute extends React.Component {
  componentWillMount() {
    const { answerToken } = this.props.answerHeader;

    if (answerToken) {
      if (isAnswer()) {
        window.addEventListener('beforeunload', this.showReloadAlert);
      }
    } else {
      // answerTokenなしは認証エラー
      this.props.showErrorDialog();
    }
  }
  state = {
    temporarySave: false,
    showSavedDialog: false,
  };

  openTemporarySaveDialog = () => {
    this.setState({ temporarySave: true });
  };

  closeTemporarySaveDialog = () => {
    this.setState({ temporarySave: false });
  };

  confirmTemporarySave = (attrResult, order) => {
    //TODO: Add temp save api call
    const attributeResultsTillCurrentPage = Object.fromEntries(
      Object.entries(attrResult).filter(([key]) => Number(key) < order)
    );
    const { locale } = this.props;
    const params = {
      tempSavedPath: '/answer_attribute',
      attrResult: attributeResultsTillCurrentPage,
      localeId: locale.id,
      url: storage.getUrlToken(),
      token: storage.getToken(),
      survey_id: storage.getSurveyId(),
    };
    window.removeEventListener('beforeunload', this.showReloadAlert);
    this.props.startTemporarySave(params)
    .then(() => {
      // Close first dialog
      this.setState({ temporarySave: false });
  
      // Show second dialog
      this.setState({ showSavedDialog: true });
    })
    .catch(() => {
      // Optionally handle error
    });
  };

  componentWillUnmount() {
    if (isAnswer()) {
      window.removeEventListener('beforeunload', this.showReloadAlert);
    }
  }

  showReloadAlert(e) {
    e.returnValue = '回答は削除されます。';
  }

  selectItem(attrItem) {
    const { currentSurveyAttr, surveyAttrs } = this.props.answerAttribute;

    this.props.selectItem(currentSurveyAttr, attrItem, surveyAttrs.length);
  }

  render() {
    const {
      classes,
      answerAttribute,
      isEffecting,
      location,
      answerResult,
      answerStart,
    } = this.props;
    const { currentSurveyAttr, surveyAttrs } = answerAttribute;
    const { isRespondent } = answerStart;
    const { order, attrName, attrItems } = currentSurveyAttr;
    const { handlePrevBtn } = this.props; // action
    const id = storage.getSurveyId();

    return (
      <div>
        <Dialog
          open={this.state.temporarySave}
          onClose={this.closeTemporarySaveDialog}
          PaperProps={{
            style: {
              padding: '30px',
              borderRadius: '8px',
            },
          }}
        >
          <DialogContent
            style={{
              marginTop: '10px',
              textAlign: 'center',
              borderBottom: 'none',
            }}
          >
            <Typography
              variant='body1'
              style={{ fontSize: '1.6rem', lineHeight: '2.4rem' }}
            >
              回答を一時保存して中断します。
              <br />
              よろしいですか？
            </Typography>
          </DialogContent>

          <DialogActions
            style={{
              justifyContent: 'space-between',
              padding: '20px 30px',
            }}
          >
            <Button raised onClick={this.closeTemporarySaveDialog}>
              キャンセル
            </Button>

            <Button
              raised
              onClick={() => {
                const { attrResult } = answerResult;
                this.confirmTemporarySave(attrResult, order);
              }}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.showSavedDialog}
          onClose={() => {}} // Disable click-outside close
          disableBackdropClick // IMPORTANT: Prevent outside close
          disableEscapeKeyDown // Prevent ESC key close
          PaperProps={{
            style: {
              padding: '30px',
              borderRadius: '8px',
            },
          }}
        >
          <DialogContent
            style={{
              marginTop: '10px',
              textAlign: 'center',
              borderBottom: 'none',
            }}
          >
            <Typography
              variant='body1'
              style={{ fontSize: '1.6rem', lineHeight: '2.4rem' }}
            >
              一時保存しました。
            </Typography>
          </DialogContent>

          <DialogActions style={{ justifyContent: 'center', paddingTop: 20 }}>
            <Button
              raised
              style={{
                padding: '10px 50px',
              }}
              onClick={() => {
                this.setState({ showSavedDialog: false });
                this.props.confirmedTemporarySave();
              }}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
        <Paper className={classes.container}>
          <div className={classes.attrNameDiv}>
            <span className={classes.attrName}>{`${order}. ${attrName}`}</span>
          </div>

          <div className={classes.selectButtonsDiv}>
            <div className={classes.selectButtonsGrid}>
              {attrItems.map((attrItem) => (
                <Button
                  raised
                  key={attrItem.id}
                  classes={{
                    raised: classes.selectBtnRaised,
                  }}
                  className={classes.selectButton}
                  onClick={() => {
                    if (!isEffecting) {
                      this.selectItem(attrItem);
                    }
                  }}
                >
                  {attrItem.itemName}
                </Button>
              ))}
            </div>
          </div>

          <div className={classes.progressWrapper}>
            <div className={classes.progress}>
              <div className={classes.progressLabel}>
                <span>{`${order} / ${surveyAttrs.length}`}</span>
              </div>

              <LinearProgress
                mode='determinate'
                value={(order / surveyAttrs.length) * 100}
                className={classes.progressBar}
                classes={{ primaryColorBar: classes.progressBarColor }}
              />
            </div>
          </div>

          <div className={classes.footer}>
            <div className={classes.btnGroup}>
              <div>
                <Button
                  raised
                  dense
                  onClick={() => {
                    if (!isEffecting) {
                      handlePrevBtn(currentSurveyAttr.order);
                    }
                  }}
                >
                  {order === 1 ? '前へ' : '前の属性へ'}
                </Button>
              </div>
              <div>
                {location.pathname === '/answer/answer_attribute' &&
                  order > 1 &&
                  id != null &&
                  id != undefined &&
                  isRespondent && (
                    <Button
                      raised
                      dense
                      className={classes.tempSaveBtn}
                      onClick={() => {
                        if (!isEffecting) {
                          this.openTemporarySaveDialog();
                        }
                      }}
                    >
                      {'一時保存'}
                    </Button>
                  )}
              </div>
            </div>
          </div>
        </Paper>
      </div>
    );
  }
}

export default withStyles(isMobile.any ? mobileStyles : browserStyles)(
  AnswerAttribute
);



// WEBPACK FOOTER //
// ./src/components/answer/AnswerAttribute.jsx